var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBinAdminIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_3_80",
    "data-name": "Component 3 \\u2013 80",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 28.8,
    viewBox: "0 0 30 28.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_13",
    "data-name": "Rectangle 13",
    fill: "#fff",
    stroke: "#e0e7ff",
    strokeWidth: 1,
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 28.8,
    rx: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 27.8,
    rx: 3.5,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "delete-bin-6-line",
    transform: "translate(7.931 8.319)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22970",
    "data-name": "Path 22970",
    d: "M0,0H14.137V14.137H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22971",
    "data-name": "Path 22971",
    d: "M4.945,3.178V2h5.891V3.178h2.945V4.356H12.6v8.836a.589.589,0,0,1-.589.589H3.767a.589.589,0,0,1-.589-.589V4.356H2V3.178ZM4.356,4.356V12.6h7.069V4.356ZM6.123,6.123H7.3v4.712H6.123Zm2.356,0H9.658v4.712H8.48Z",
    transform: "translate(-0.822 -0.822)",
    fill: "#e1432a",
    stroke: "#fff",
    strokeWidth: 0.3
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinAdminIcon);
export default __webpack_public_path__ + "static/media/bin-admin-icon.77910df9a409d0ce7a168f5eba2f61c3.svg";
export { ForwardRef as ReactComponent };